import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable } from 'rxjs';
import {
  CourseDataV2,
  CourseDetailsModelV2,
  LoaderService,
  Logger,
  RouterStoreService,
  ToastService,
  selectCourseV2,
} from 'thkee-common';

const log = new Logger('CourseSidebarComponent');
@UntilDestroy()
@Component({
  selector: 'app-course-sidebar',
  templateUrl: './course-sidebar.component.html',
  styleUrls: ['./course-sidebar.component.scss'],
  standalone: true,
  imports: [NgIf, AsyncPipe, RouterLink, AngularSvgIconModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseSidebarComponent implements OnInit {
  activeRoute: string = '';
  courseId$: Observable<string>;
  courseData?: CourseDataV2;
  course$!: Observable<CourseDetailsModelV2>;
  preview: boolean = false;

  queryParams: { preview: boolean } = {
    preview: true,
  };

  isUpdating$ = this.loaderService.response('prevent-button-action-based-on-api-response');
  isUpdating: boolean = false;

  constructor(
    private readonly store: Store,
    private readonly routerStoreService: RouterStoreService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.courseId$ = this.routerStoreService.getParam('courseId');
    this.routerStoreService.getUrl().subscribe((data) => {
      this.activeRoute = data;
    });
  }

  ngOnInit(): void {
    this.course$ = this.store.select(selectCourseV2);
    this.isUpdating$.pipe(untilDestroyed(this)).subscribe((savingDetails) => {
      if (savingDetails === 'loading') {
        this.isUpdating = true;
      } else {
        this.isUpdating = false;
      }
      this.cdr.markForCheck();
    });
    this.preview = this.activatedRoute.snapshot.queryParams['preview'] === 'true';
  }

  isActive(route = 'intended-learners') {
    let endPath = '';
    if (this.preview) {
      endPath = route + '?preview=true';
    } else {
      endPath = route;
    }
    return this.activeRoute.endsWith(endPath) ? true : false;
  }

  isActiveChild(route = '/', slice: number) {
    const parts = this.activeRoute.split('/');
    const firstTwoParts = parts.slice(0, slice).join('/');
    return firstTwoParts.endsWith(route) ? true : false;
  }
  hideSidebar(url: string) {
    this.loaderService.loaderAction('instructor-course-mobile-toggle', 'success');
    if (this.isUpdating) {
      this.toastService.info({
        message: $localize`We are currently saving your changes. This will only take a moment.`,
      });
    } else {
      if (this.preview) {
        this.router.navigate([url], { queryParams: this.queryParams });
      } else {
        this.router.navigate([url]);
      }
    }
    this.cdr.markForCheck();
  }
}
